import { keyframes } from '@chakra-ui/react';
import {
  ColorMode,
  getColorToken,
} from '@allergan-data-labs/alle-elements-core';
import {
  EndCapShape,
  ProgressColorScheme,
} from '@allergan-data-labs/alle-elements-progress-bar';
import { CSSProperties } from 'react';

export const getBackgroundColor = (
  colorScheme: ProgressColorScheme
): string => {
  switch (colorScheme) {
    case 'brand':
      return 'Container/Brand/Subtle 1';
    case 'success':
      return 'Container/Status/Success subtle 1';
    default:
      return 'Container/Neutral/Disabled/Default'; //action
  }
};

export const getBarColor = (colorScheme: ProgressColorScheme): string => {
  switch (colorScheme) {
    case 'brand':
      return 'Container/Brand/Medium 3';
    case 'success':
      return 'Container/Status/Success bold 1';
    default:
      return 'Container/Neutral/Inverted'; //action
  }
};

export const getContainerStyles = ({
  lineThickness = 2,
  colorMode = 'light',
  colorScheme = 'brand',
}: {
  lineThickness?: number;
  colorScheme?: ProgressColorScheme;
  colorMode?: ColorMode;
}): CSSProperties => {
  return {
    strokeWidth: `${lineThickness}px`,
    fill: 'none',
    stroke: `${getColorToken(getBackgroundColor(colorScheme), colorMode)}`,
  };
};

export const getBarStyles = ({
  animate = true,
  circleWidth,
  colorMode = 'light',
  colorScheme = 'brand',
  endCapShape = 'round',
  isIndeterminate = false,
  lineThickness = 2,
  value,
}: {
  animate?: boolean;
  circleWidth: number;
  colorMode?: ColorMode;
  colorScheme?: ProgressColorScheme;
  endCapShape?: EndCapShape;
  isIndeterminate?: boolean;
  lineThickness?: number;
  value?: number;
}): CSSProperties => {
  const radius = circleWidth / 2 - lineThickness;
  const dashArray = radius * 2 * Math.PI;
  const dashOffset =
    dashArray -
    (dashArray * (isIndeterminate || value === undefined ? 30 : value)) / 100;

  return {
    strokeWidth: `${lineThickness}px`,
    fill: 'none',
    stroke: `${getColorToken(getBarColor(colorScheme), colorMode)}`,
    strokeDasharray: dashArray,
    strokeDashoffset: dashOffset,
    strokeLinecap: endCapShape === 'flat' ? 'butt' : 'round',
    transition: animate ? 'stroke-dashoffset .25s' : 'none',
  };
};

export const getRotationStyle = ({
  isIndeterminate = false,
  value,
}: {
  isIndeterminate?: boolean;
  value?: number;
}): CSSProperties => {
  const spin = keyframes`
    100% {
        transform: rotate(1turn);
    }
    `;
  const animation =
    isIndeterminate || value === undefined
      ? `${spin} 1s infinite linear`
      : 'none';

  return {
    animation: animation,
  };
};
